import { render } from "./TabBar.vue?vue&type=template&id=269b9dc0&scoped=true&ts=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"

import "./TabBar.vue?vue&type=style&index=0&id=269b9dc0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269b9dc0"]])

export default __exports__